import dayjsTimezone from "dayjs/plugin/timezone";
import dayjs, { type ConfigType } from "dayjs";
import dayjsUtc from "dayjs/plugin/utc";

dayjs.extend(dayjsTimezone);
dayjs.extend(dayjsUtc);

export const utc = (n?: ConfigType) => dayjs.utc(n);

export const utcOffsetLabel = (timezone: string) => {
  const date = utc().tz(timezone).format("Z").replace(":00", "");
  const offset = Number(date.replace("+", ""));
  return `(UTC${offset >= 0 ? `+${offset}` : offset})`;
};
